<template>
  <td :class="classCss" style="font-size: 11px;">
    <a v-if="IsCheckbox" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"><input type="checkbox" v-model="isChecked" :value="value" @change="check($event)" :disabled="disabled"></a>
    <a v-if="IsText" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(status === false)}">{{ (value) ? value: 'N/D' }}</a>
    <a v-if="IsYesNo" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(status === false)}">{{ (valueBool) ? $lang.Common.Yes : $lang.Common.No }}</a>
    <a v-if="IsNumber" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(status === false)}">{{ value }}</a>
    <a v-if="IsDatetime" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(status === false)}">{{ (value) ? moment(new Date(value)).format('DD/MM/YYYY HH:mm') : 'N/D' }}</a>
    <a v-if="IsDateOnly" v-on:click="$emit('Edit', obj)" href="javascript:void(0)"  v-bind:class="{'text-danger':(status === false)}">{{ (value) ? moment(new Date(value)).format('DD/MM/YYYY') : 'N/D' }}</a>
    <div v-if="IsStatus" v-on:click="$emit('Edit', obj)">
      <span v-if="status" class="badge badge-success text-toupper">{{$lang.Common.Status.Active}}</span>
      <span v-else class="badge badge-danger text-toupper">{{$lang.Common.Status.Inactive}}</span>
    </div>
    <div v-if="IsActionsButtons">
      <i v-show="HasChange" v-if="status" v-on:click="$emit('Change', obj)" class="fa fa-close text-danger icone-grid" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonInactive"></i>
      <i v-show="HasChange" v-else v-on:click="$emit('Change', obj)" class="fa fa-check text-success icone-grid" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonActive"></i>
      &nbsp;
      <b-dropdown v-if="HasDelete" variant="link" size="sm" no-caret>
        <template slot="button-content">
          <i class="fa fa-trash text-secundary icone-grid"></i><span class="sr-only">{{$lang.Common.Buttons.Delete}}</span>
        </template>
        <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
        <b-dropdown-item href="javascript:void(0);" v-on:click="$emit('Delete', obj)">{{$lang.Common.Yes}}</b-dropdown-item>
        <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
      </b-dropdown>
    </div>
    <div v-if="IsActionsDetails">
      <i v-if="HasChange" v-on:click="$emit('Details', obj)" class="fa fa-plus-square-o" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonDetails"></i>
    </div>
    <div v-if="IsLighthouse">
      <div v-if="value==0">
        <i v-if="HasChange" class="fa fa-circle font-xl" style="color: gray;" v-b-tooltip.hover title="Não contém histórico/semáforo"></i>
      </div>
      <div v-if="value==1">
        <i v-if="HasChange" class="fa fa-circle font-xl" style="color: green;"></i>
      </div>
      <div v-if="value==2">
        <i v-if="HasChange" class="fa fa-circle font-xl" style="color: yellow;"></i>
      </div>
      <div v-if="value==3">
        <i v-if="HasChange" class="fa fa-circle font-xl" style="color: red;"></i>
      </div>
      <div v-if="value==5">
        <i v-if="HasChange" class="fa fa-circle font-xl" style="color: blue;" v-b-tooltip.hover :title="description"></i>
      </div>
    </div>
  </td>
</template>
<script>
export default {
  name: 'tableColumn',
  data () {
    return {
      obj: null,
      isChecked: this.checked
    }
  },
  props: {
    status: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      required: false,
      default: 'N/D'
    },
    valueBool: {
      type: Boolean,
      required: false,
      default: false
    },
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    classCss: {
      type: String,
      required: false,
      default: 'text-center'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    IsCheckbox: {
      type: Boolean,
      required: false,
      default: false
    },
    IsText: {
      type: Boolean,
      required: false,
      default: false
    },
    IsYesNo: {
      type: Boolean,
      required: false,
      default: false
    },
    IsNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDatetime: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDateOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    IsStatus: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActionsButtons: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActionsDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    IsLighthouse: {
      type: Boolean,
      required: false,
      default: false
    },
    HasChange: {
      type: Boolean,
      required: false,
      default: true
    },
    HasDelete: {
      type: Boolean,
      required: false,
      default: true
    },
    hours: {
      type: String,
      required: false,
      default: '00:00'
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    check (e) {
      this.isChecked = e.target.checked
      this.$emit('Check', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/TableColumn.vue